// AUTH STATE
export function clearStorage() {
    localStorage.clear()
}
export function isAuthenticated() {
    return !!getUserId() && !!getAccessToken()
}

export function shouldStoreRefreshToken(isRemembered) {
    localStorage.setItem('rememberMe', isRemembered)
}

export function getShouldStoreRefreshToken() {
    return localStorage.getItem('rememberMe')
        ? JSON.parse(localStorage.getItem('rememberMe'))
        : false
}

export function removeShouldStoreRefreshToken() {
    localStorage.removeItem('rememberMe')
}

// ACCESS TOKEN
export function setUserToken({token, refreshToken, xApiKey}) {
    localStorage.setItem('accessToken', token)
    localStorage.setItem('xApiKey', xApiKey)
    if (!!getShouldStoreRefreshToken()) {
        localStorage.setItem('refreshToken', refreshToken)
    }
}

export function setAccessToken(accessToken) {
    localStorage.setItem('accessToken', accessToken)
}
export function getAccessToken() {
    return localStorage.getItem('accessToken')
}
export function removeAccessToken() {
    localStorage.removeItem('accessToken')
}

// REFRESH TOKEN
export function setRefreshToken(refreshToken) {
    localStorage.setItem('refreshToken', refreshToken)
}
export function getRefreshToken() {
    return localStorage.getItem('refreshToken')
}
export function removeRefreshToken() {
    localStorage.removeItem('refreshToken')
}

// X-API-KEY
export function setXApiKey(xApiKey) {
    localStorage.setItem('xApiKey', xApiKey)
}
export function getXApiKey() {
    return localStorage.getItem('xApiKey')
}
export function removeXApiKey() {
    localStorage.removeItem('xApiKey')
}

// USER INFO
export function setUserInfo({id, username, clientId, fullName}) {
    localStorage.setItem('id', id)
    localStorage.setItem('username', username)
    if (!!clientId) {
        localStorage.setItem('clientId', clientId)
    }

    if (!!fullName) {
        localStorage.setItem('fullName', fullName)
    }
}

export function getUserId() {
    return (
        !!localStorage.getItem('id') && JSON.parse(localStorage.getItem('id'))
    )
}

export function getUsername() {
    return localStorage.getItem('username')
}

export function setClientId(clientId) {
    localStorage.setItem('clientId', clientId)
}

export function getClientId() {
    return (
        !!localStorage.getItem('clientId') &&
        JSON.parse(localStorage.getItem('clientId'))
    )
}

export function removeClientId() {
    localStorage.removeItem('clientId')
}

// SESSION
export function setSessionId(sessionId) {
    localStorage.setItem('sessionId', sessionId)
}
export function getSessionId() {
    return localStorage.getItem('sessionId')
}
export function removeSessionId() {
    localStorage.removeItem('sessionId')
}

// MENU ITEMS
export function setMenuItems(menuItems) {
    localStorage.setItem('menuItems', menuItems)
}
export function getMenuItems() {
    return localStorage.getItem('menuItems')
}
export function removeMenuItems() {
    localStorage.removeItem('menuItems')
}
// HOSPITAL LOGO
export function setHospitalLogo(hospitalLogo) {
    localStorage.setItem('hospitalLogo', hospitalLogo)
}

export function getHospitalLogo() {
    return localStorage.getItem('hospitalLogo')
}

export function setHospitalName(hospitalName) {
    localStorage.setItem('hospitalName', hospitalName)
}

export function getHospitalName() {
    return localStorage.getItem('hospitalName')
}

export function setNhsNumber(nhsNumber) {
    localStorage.setItem('nhsNumber', nhsNumber)
}

export function getNhsNumber() {
    return localStorage.getItem('nhsNumber')
}

export function setHospitalSelect(hospitalId) {
    localStorage.setItem('hospitalId', hospitalId)
}

export function getHospitalSelect() {
    return localStorage.getItem('hospitalId')
        ? JSON.parse(localStorage.getItem('hospitalId'))
        : null
}

export function setUserRole(userRole) {
    localStorage.setItem('userRole', userRole)
}
export function getUserRole() {
    return localStorage.getItem('userRole')
}
export function removeUserRole() {
    localStorage.removeItem('userRole')
}

//TAC ACCEPTANCE
export function setTacAcceptance(accept) {
    localStorage.setItem('tacAcceptance', accept)
}
export function getTacAcceptance() {
    return localStorage.getItem('tacAcceptance')
        ? JSON.parse(localStorage.getItem('tacAcceptance'))
        : false
}

//ACCESS CONFIG PATIENT PORTAL
export function setAccessConfig(accessConfig) {
    localStorage.setItem(
        'accessConfig',
        accessConfig ? JSON.stringify(accessConfig) : '',
    )
}
export function getAccessConfig() {
    return localStorage.getItem('accessConfig')
        ? JSON.parse(localStorage.getItem('accessConfig'))
        : {}
}

// TIMEZONE
export function setTimezone(timezone) {
    localStorage.setItem('timezone', timezone)
}
export function getTimezone() {
    return localStorage.getItem('timezone')
        ? localStorage.getItem('timezone')
        : null
}
export function storeAllUserData(data) {
    setUserInfo(data?.userInfo)
    setUserToken(data?.userToken)
    setXApiKey(data?.xApiKey)
    setSessionId(data?.sessionId)
    setMenuItems(data?.menuItems)
    setAccessConfig(data?.accessConfig)

    if (data?.userInfo && data.userInfo?.systemRole === 'super_admin') {
        setSuperAdminRole()
    } else setUserRole(data?.userRole)

    setTacAcceptance(data?.tacAcceptance || false)
}

// SUPER ADMIN ROLE
export function setSuperAdminRole() {
    localStorage.setItem('superAdminRole', true)
}

export function getSuperAdminRole() {
    return localStorage.getItem('superAdminRole')
        ? JSON.parse(localStorage.getItem('superAdminRole'))
        : false
}

export function removeSuperAdminRole() {
    localStorage.removeItem('superAdminRole')
}

// ATTEMPT
export function getAuthAttempt() {
    return localStorage.getItem('attempt')
}

export function setAuthAttempt(attempt) {
    localStorage.setItem('attempt', attempt)
}

export function removeAuthAttempt() {
    localStorage.removeItem('attempt')
}

// CHAT
export function setIsOpenChat(isOpen) {
    localStorage.setItem('isOpenChat', isOpen)
}

export function getIsOpenChat() {
    return localStorage.getItem('isOpenChat')
        ? JSON.parse(localStorage.getItem('isOpenChat'))
        : false
}

// NOTIFICATION SETTING

export function setNotificationSetting(notificationSetting) {
    localStorage.setItem('notificationSetting', notificationSetting)
}

export function getNotificationSetting() {
    return localStorage.getItem('notificationSetting')
}

export function removeNotificationSetting() {
    localStorage.removeItem('notificationSetting')
}

// HOSPITALS BELONG
export function setHospitalsBelong(hospitalsBelong) {
    localStorage.setItem('hospitalsBelong', hospitalsBelong)
}

export function getHospitalsBelong() {
    return localStorage.getItem('hospitalsBelong')
}

export function removeHospitalsBelong() {
    localStorage.removeItem('hospitalsBelong')
}

// WIDGET
export function setWidget(widget) {
    localStorage.setItem('widget', widget)
}

export function getWidget() {
    return localStorage.getItem('widget')
}

export function removeWidget() {
    localStorage.removeItem('widget')
}

// WIDGET
export function setAdvanceColumns(cols) {
    localStorage.setItem('advanceColumns', cols)
}

export function getAdvanceColumns() {
    return localStorage.getItem('advanceColumns')
}

export function removeAdvanceColumns() {
    localStorage.removeItem('advanceColumns')
}
